import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    link: {
        margin: theme.spacing(1, 1.5),
    },
    paperBackground: {
        backgroundColor: theme.palette.background.paper,
    },
    cardGrid: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(8),
    },
    keyBenefits: {
        padding: theme.spacing(16, 0),
    },
    keyBenefitItem: {
        textAlign: 'center',
    },
}));
